import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

/**
 * Renders a single proposal layout block (heading, paragraph, row, column, etc.) for public/preview views.
 */
export function renderProposalBlock(block, keyPrefix = 'block') {
  const blockKey = `${keyPrefix}-${block.id || 'item'}`;
  switch (block.type) {
    case 'heading': {
      const Heading = block.props?.level === 1 ? 'h4' : block.props?.level === 3 ? 'h6' : 'h5';
      const headingStyles = Heading === 'h5' ? { fontSize: '1.2rem', fontWeight: 500 } : {};
      return (
        <Typography key={blockKey} component={Heading} sx={{ mt: 2, mb: 1, ...headingStyles }}>
          {block.props?.text || ''}
        </Typography>
      );
    }
    case 'paragraph':
      return (
        <Typography key={blockKey} variant="body1" sx={{ whiteSpace: 'pre-wrap', mb: 1 }}>
          {block.props?.text || ''}
        </Typography>
      );
    case 'divider':
      return <Divider key={blockKey} sx={{ my: 2 }} />;
    case 'image':
      return block.props?.url ? (
        <Box key={blockKey} sx={{ my: 2 }}>
          <Box component="img" src={block.props.url} alt={block.props?.alt || ''} sx={{ maxWidth: '100%', height: 'auto', borderRadius: 1 }} />
        </Box>
      ) : null;
    case 'row': {
      const children = Array.isArray(block.children) ? block.children : [];
      return (
        <Box key={blockKey} sx={{ display: 'flex', gap: 2, flexWrap: { xs: 'wrap', md: 'nowrap' }, alignItems: 'stretch', my: 2 }}>
          {children.map((child, idx) => renderProposalBlock(child, `${blockKey}-row-${idx}`))}
        </Box>
      );
    }
    case 'column': {
      const children = Array.isArray(block.children) ? block.children : [];
      return (
        <Box key={blockKey} sx={{ flex: { md: '1 1 0' }, minWidth: 0 }}>
          {children.map((child, idx) => renderProposalBlock(child, `${blockKey}-col-${idx}`))}
        </Box>
      );
    }
    default:
      return null;
  }
}
